import { styled } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

export const StyledWarningIcon = styled(WarningIcon)`
  color: #ee7575;
  width: 30px;
  height: 30px;
`;
